import clsx from 'clsx'

import Avatar from 'app/components/Avatar'
import styles from './styles.module.scss'

function LinearAvatarsCollection({ operators, className, showTooltip = false, avatarSize = 30, ...rest }) {
  return (
    <div className={clsx(className, styles.avatars)}>
      {operators.map((op) => (
        <div className={styles.avatar} key={op.id}>
          <Avatar
            {...rest}
            backgroundSize={avatarSize}
            avatarInfo={{
              name: op.name,
              url: op.avatar,
            }}
            withBorder={true}
            showTooltip={showTooltip}
            key={op.id}
          />
        </div>
      ))}
    </div>
  )
}

export default LinearAvatarsCollection
